import React, {PropTypes} from 'react';
import Display from '../parts/display';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as siteActions from '../../actions/siteActions';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import ClientsBlock from '../clientsBlock';
import BlogBlock from '../blogBlock';
import Select from '../parts/select';


class BlogPage extends React.Component {
	constructor() {
		super();
		this.state = {
			animated: false,
			selected: '',
			pageSlug: false,
			selectedFilter: false,
			activeType: false
		};
		this.portfolioSelected = this.portfolioSelected.bind(this);
		this.getServiceType = this.getServiceType.bind(this);
		this.loadMorePosts = this.loadMorePosts.bind(this);
		this.loadAllPosts = this.loadAllPosts.bind(this);
		this.loadPostsByService = this.loadPostsByService.bind(this);
	}
	componentWillMount(){
		window.scrollTo(0,0);
	}
	componentWillUnmount(){
		this.props.actions.loadBlogPosts(6,1);
		this.props.actions.clearState();
	}
	componentDidMount() {
		this.props.actions.showNavBar(true);
		this.props.actions.showMenu(true);
		if((this.props.location.pathname.match(/\//g) || []).length == 2){
			let name = this.props.location.pathname.substring(11, this.props.location.pathname.length);
			this.props.actions.loadService(_find(this.props.site.services, {slug: name}));
			this.setState({
				pageSlug: name
			});
		}
		if(this.props.location.query.slug) {
			this.props.actions.loadPostsByService(this.props.location.query.slug,this.props.location.query.taxonomy, 6, 1);
			if(this.props.services){
				this.setState({
					selectedFilter: _find(this.props.site.services, {slug: this.props.location.query.slug}).name
				});
			}

		}else if(this.props.site.posts.length < 4){
			this.props.actions.loadBlogPosts(6,1);
		}

	}
	componentWillReceiveProps(next){
		if(next.site.services !== this.props.site.services){
			if(this.props.location.query.slug) {
				this.setState({
					selectedFilter: _find(next.site.services, {slug: this.props.location.query.slug}).name
				});
			}
		}
	}
	portfolioSelected(name){
		this.setState({
			selected: name
		});
	}
	getServiceType(type){
		return _filter(this.props.site.services, {type: type});
	}
	loadMorePosts(){
		if(this.props.site.postsFilter){
			this.props.actions.loadPostsByService(this.props.site.postsFilter.slug,this.props.site.postsFilter.taxonomy, 6, this.props.site.postsPage + 1);
			this.setState({
				selectedFilter: _find(this.props.site.services, {slug: this.props.site.postsFilter.slug}).name
			});
		}else{
			this.props.actions.loadBlogPosts(6,this.props.site.postsPage + 1);
		}
	}
	loadAllPosts(){
		this.props.actions.loadBlogPosts(6,1);
		this.setState({
			selectedFilter: false,
			activeType: false
		});
	}
	loadPostsByService(slug, taxonomy){
		if(slug === 'any'){
			this.props.actions.loadBlogPosts(6,1);
			this.setState({
				selectedFilter: false
			});
		}else{
			this.props.actions.loadPostsByService(slug, taxonomy, 6, 1);
			this.setState({
				selectedFilter: _find(this.props.site.services, {slug: slug}).name
			});
		}
		this.setState({
			activeType: slug
		});
	}
	render() {
		return (
			<div className="services-page animated fadeIn portfolio-page blog-page">
				<div className="portfolio-top">
					<div className="container">
						<div className="row">
							<h1><span>/</span> Blog</h1>
							<div className="dash-separator"></div>
							<div className="filters">
								<span>Filter by<i>::</i></span>
								<span className="all-btn" onClick={this.loadAllPosts}>ALL</span>
								<span>|</span>
								<Select items={this.props.site.specialisms} name="Specialism" updateItems={this.loadPostsByService} activeSlug={this.state.activeType} />
								<span>|</span>
								<Select items={this.props.site.skillsets} name="Skillset" updateItems={this.loadPostsByService} activeSlug={this.state.activeType} />
							</div>
							<Display if={this.state.selectedFilter}>
								<h2 className="portfolio-name" dangerouslySetInnerHTML={{__html: this.state.selectedFilter}}></h2>
							</Display>
							{/*<Display if={!this.state.selectedFilter}>*/}
								{/*<h2 className="portfolio-name">All</h2>*/}
							{/*</Display>*/}
						</div>
					</div>
				</div>
				<BlogBlock posts={this.props.site.posts} blogPage maxPosts={99} loading={this.props.site.loadingPosts} />
				<Display if={this.props.site.posts.length % 6 === 0 && !this.props.site.loadingPosts}>
					<Display if={!this.props.site.noPostsFound}>
						<div className="load-more-arrow" onClick={this.loadMorePosts}>
							<i className="fa fa-angle-down"></i>
						</div>
					</Display>
					<Display if={this.props.site.noPostsFound}>
						<p className="no-posts-found">No Posts Found</p>
					</Display>
				</Display>
				<ClientsBlock clients={this.props.site.selectedClients} />
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		site: state.site
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(siteActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(BlogPage);



/** WEBPACK FOOTER **
 ** ./src/js/components/blog/blogPage.js
 **/